import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { SectionHeading } from '../Landing/landingUi';

/*
 * Ana sayfa portalının ortak parçaları (tanıtım sayfalarının landingUi diliyle aynı).
 * Renkler: bölüm/hedef kitle vurguları. Açık modda küçük metinde ≥4.5:1, koyu modda kâğıt zeminde ≥4.5:1.
 */

export const PORTAL_TONES = {
  roommates: { light: '#2563EB', dark: '#60A5FA' },
  listings: { light: '#0E7490', dark: '#22D3EE' },
  propertyTracking: { light: '#047857', dark: '#34D399' },
  agencies: { light: '#4F46E5', dark: '#A5B4FC' },
};

export const usePortalTone = (key) => {
  const theme = useTheme();
  const tone = PORTAL_TONES[key] || PORTAL_TONES.roommates;
  return theme.palette.mode === 'dark' ? tone.dark : tone.light;
};

/** Bölüm başlığı + sağda "tümünü gör" türü eylemler (mobilde alt alta). */
export const SectionHeaderRow = ({ id, eyebrow, title, subtitle, actions }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: { xs: 'flex-start', md: 'flex-end' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 2,
      mb: { xs: 3, md: 4 },
    }}
  >
    <SectionHeading id={id} align="left" eyebrow={eyebrow} title={title} subtitle={subtitle} sx={{ mb: 0, maxWidth: 720 }} />
    {actions ? <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flexShrink: 0 }}>{actions}</Box> : null}
  </Box>
);

export const ViewAllButton = ({ to, children }) => (
  <Button component={RouterLink} to={to} variant="text" endIcon={<ArrowForwardRoundedIcon />} sx={{ fontWeight: 700 }}>
    {children}
  </Button>
);

/**
 * Önizleme satırı: mobilde yatay kaydırmalı (scroll-snap), sm'de 2, md'de 4 sütun ızgara.
 * Sayfa yatay kaymaz; kaydırma yalnızca bu listenin içinde.
 */
export const PreviewRow = ({ label, children }) => (
  <Box
    component="ul"
    aria-label={label}
    sx={{
      listStyle: 'none',
      m: 0,
      p: 0,
      display: 'grid',
      gap: { xs: 2, md: 2.5 },
      gridAutoFlow: { xs: 'column', sm: 'row' },
      // Sabit %80 sütun: minmax(0, …) olursa sütunlar daralıp hepsi ekrana sığmaya çalışır
      gridAutoColumns: { xs: '80%', sm: 'auto' },
      gridTemplateColumns: { sm: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' },
      overflowX: { xs: 'auto', sm: 'visible' },
      scrollSnapType: { xs: 'x mandatory', sm: 'none' },
      scrollbarWidth: 'thin',
      mx: { xs: -2, sm: 0 },
      px: { xs: 2, sm: 0 },
      scrollPaddingLeft: { xs: 16, sm: 0 },
      pb: { xs: 1.5, sm: 0 },
      '& > li': { minWidth: 0, scrollSnapAlign: 'start' },
    }}
  >
    {children}
  </Box>
);

/** Boş / hata durumu kartı. */
export const PreviewNotice = ({ icon, text, children }) => (
  <Card
    sx={{
      p: { xs: 2.5, md: 3 },
      display: 'flex',
      alignItems: { xs: 'flex-start', sm: 'center' },
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
    }}
  >
    {icon}
    <Typography sx={{ flex: 1, color: 'text.secondary', lineHeight: 1.6 }}>{text}</Typography>
    {children ? <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{children}</Box> : null}
  </Card>
);
